export default function DongdongIntro() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-2">
        <div className="order-2 lg:order-1">
          <span className="inline-flex rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900 whitespace-nowrap">
            核心设定 · 洞洞含义
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            洞洞，不只是一个可爱的称呼
          </h2>
          <p className="mt-5 text-sm leading-7 text-foreground-700 md:text-base">
            在洞洞杂货铺的世界里，「洞洞」无处不在——它们出现在墙面上、货架的缝隙里、
            旧木板的节疤中。乍看之下，它们只是这家小店随性的小装饰。
            但随着故事推进你会发现，每一个洞洞都是通往其他世界的入口，
            是记忆的裂隙，也是人与人之间看不见的联系。
          </p>
          <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base">
            洞洞拥有自己的法则：它们只开在「需要」的地方，而走进洞洞的人，
            总要留下一小段记忆作为交换。正是这套独特的设定，
            让整部漫画的日常与奇幻互相交织，构成了它深邃又温暖的世界观。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href="/worldview"
              className="inline-flex items-center gap-2 rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 whitespace-nowrap"
            >
              深入解析洞洞含义
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20hand%20drawn%20illustration%20of%20several%20glowing%20mysterious%20circular%20holes%20in%20a%20wooden%20wall%20of%20a%20grocery%20store%2C%20soft%20golden%20light%20spilling%20through%2C%20sparkles%2C%20amber%20and%20cream%20palette%2C%20storybook%20fantasy%20style%2C%20gentle%20mysterious%20atmosphere&width=900&height=680&seq=home-intro-hole&orientation=portrait"
            alt="洞洞杂货铺中发光的圆形洞洞设定插画"
            className="h-72 w-full rounded-3xl object-cover md:h-96"
          />
        </div>
      </div>
    </section>
  );
}